import {isNil} from "lodash"
import {combineReducers} from "redux"
import {
    CONNECT_USER_FAILURE,
    CONNECT_USER_SUCCESS,
    DISCONNECT_USER,
} from "../../../../actions/sessionStorage/user/userActionTypes"
import {CommonRequestKeys} from "../../../../common/constants/requests"
import {getPermissionsFromToken} from "../../../../utils/authUtil"
import {REQUEST_FAILURE, REQUEST_SUCCESS} from "../../../requests/requestsReducer"

const authority = () => {
    const mfaSessionId = (state = null, action = {}) => {
        switch (action.type) {
            case CONNECT_USER_SUCCESS:
                if (!isNil(action.response.mfaSessionId)) {
                    return action.response.mfaSessionId
                }
            case REQUEST_SUCCESS:
                if (action.requestKeyName === CommonRequestKeys.USER_AUTHORITY) {
                    if (!isNil(action.response.mfaSessionId)) {
                        return action.response.mfaSessionId
                    }
                }
                return state
            case REQUEST_FAILURE:
                if (action.requestKeyName === CommonRequestKeys.USER_AUTHORITY) {
                    return null
                }
                return state
            case CONNECT_USER_FAILURE:
            case DISCONNECT_USER:
                return null
            default:
                return state
        }
    }

    const token = (state = null, action = {}) => {
        switch (action.type) {
            case CONNECT_USER_SUCCESS:
                return action.response.token
            case REQUEST_SUCCESS:
                if (action.requestKeyName === CommonRequestKeys.USER_AUTHORITY) {
                    return action.response.token
                }
                return state
            case REQUEST_FAILURE:
                if (action.requestKeyName === CommonRequestKeys.USER_AUTHORITY) {
                    return null
                }
                return state
            case CONNECT_USER_FAILURE:
            case DISCONNECT_USER:
                return null
            default:
                return state
        }
    }

    const expirationDate = (state = null, action = {}) => {
        switch (action.type) {
            case CONNECT_USER_SUCCESS:
                return action.response.expirationDate
            case REQUEST_SUCCESS:
                if (action.requestKeyName === CommonRequestKeys.USER_AUTHORITY) {
                    return action.response.expirationDate
                }
                return state
            case REQUEST_FAILURE:
                if (action.requestKeyName === CommonRequestKeys.USER_AUTHORITY) {
                    return null
                }
                return state
            case CONNECT_USER_FAILURE:
            case DISCONNECT_USER:
                return null
            default:
                return state
        }
    }

    const permissions = (state = [], action = {}) => {
        switch (action.type) {
            case CONNECT_USER_SUCCESS:
                return getPermissionsFromToken(action.response.token)
            case REQUEST_SUCCESS:
                if (action.requestKeyName === CommonRequestKeys.USER_AUTHORITY) {
                    return getPermissionsFromToken(action.response.token)
                }
                return state
            case REQUEST_FAILURE:
                if (action.requestKeyName === CommonRequestKeys.USER_AUTHORITY) {
                    return []
                }
                return state
            case CONNECT_USER_FAILURE:
            case DISCONNECT_USER:
                return []
            default:
                return state
        }
    }

    return combineReducers({
        mfaSessionId,
        token,
        expirationDate,
        permissions,
    })
}

export default authority

/**
 * Get the token from the state.
 */
export const getMfaSessionId = state => state.mfaSessionId

/**
 * Get the token from the state.
 */
export const getToken = state => state.token

/**
 * Get the expiration date.
 */
export const getExpirationDate = state => state.expirationDate

/**
 * Get the user permissions from the state.
 */
export const getPermissions = state => state.permissions
